import { log } from "~features/seated-reservation/helpers/stateLogger";
import { setState, getState } from "../non-seated-reservation-store";
import {
  TTrackingContext,
  trackAddToCart,
  trackRemoveFromCart,
  trackSelectItem,
} from "~lib/helpers/googleAnalyticsTracking";
import { IReleaseTicket } from "~features/nonseated-reservation/nonseated-reservation.types";

type Payload = {
  id: string;
  ticketType: IReleaseTicket;
  quantity: number;
};

export function updateSelectedTicketTypes(payload: Payload) {
  log("updateSelectedTicketTypes", payload);

  const state = getState();

  const trackingData: TTrackingContext = {
    ...state.trackingContext,
    ticketType: payload.ticketType,
  };

  trackSelectItem(trackingData);

  const ticketTypes = state.selectedTicketTypes[payload.id] || [];

  let updatedTicketTypes: IReleaseTicket[] = [];

  const existingTicketType = ticketTypes.find(
    (tt) => tt.id === payload.ticketType.id
  );

  if (existingTicketType === undefined && payload.quantity > 0) {
    // Add ticket type for the first time
    updatedTicketTypes = [
      ...ticketTypes,
      {
        ...payload.ticketType,
        quantity: payload.quantity,
      },
    ];

    trackAddToCart({
      ...trackingData,
      ticketType: updatedTicketTypes[0],
    });
  } else if (existingTicketType && payload.quantity <= 0) {
    // Remove ticket type from selection
    updatedTicketTypes = ticketTypes.filter(
      (tt) => tt.id !== payload.ticketType.id
    );

    trackRemoveFromCart(trackingData);
  } else {
    // Update quantity of existing ticket type
    updatedTicketTypes = ticketTypes.map((tt) => {
      if (tt.id === payload.ticketType.id) {
        return {
          ...tt,
          quantity: payload.quantity,
        };
      }

      return tt;
    });

    const ticketForTracking = updatedTicketTypes.find(
      (tt) => tt.id === payload.ticketType.id
    );

    trackAddToCart({
      ...trackingData,
      ticketType: ticketForTracking,
    });
  }

  setState({
    selectedTicketTypes: {
      ...state.selectedTicketTypes,
      [payload.id]: updatedTicketTypes,
    },
  });
}

/* Check dependacies
if (!isAdmin) {
  // Remove any selected entities that no longer meet the purchase restriction
  for (const selectedItem of itemsToAdd) {
    if (
      !isAvailableForSelection(
        itemsToAdd,
        selectedItem,
        ticketsSoldForUser
      ) ||
      selectedItem.quantity <= 0
    ) {
      const index = itemsToAdd.findIndex(
        (item) => item.id === selectedItem.id
      );

      itemsToAdd.splice(index, 1);
    }
  }

  // Display error modal if purchase restrictions fail
  if (value > 0) {
    let success = itemsToAdd.some((item) => item.id === id);

    // Check what user has previously purchased
    if (!success) {
      success = ticketsSoldForUser.some((item) =>
        [item.ticketType?.id, item.membershipType?.id].includes(id)
      );
    }

    if (!success && current?.purchaseRestrictionsHelpText) {
      const purchaseRestrictions = current.purchaseRestrictionsHelpText;

      if (purchaseRestrictions.length > 0) {
        // TODO: Error modal
      }
    }
  }
}*/
